import React from 'react'
import { styled } from '@mui/material/styles'
import Badge from '@mui/material/Badge'
import Avatar from '@mui/material/Avatar'
import Stack from '@mui/material/Stack'
import { apiUrl } from '../../services/Api/request'

const StyledBadge = styled(Badge)(({ theme }) => ({
  '& .MuiBadge-badge': {
    backgroundColor: '#A4CF52',
    color: '#A4CF52',
    boxShadow: `0 0 0 2px ${theme.palette.background.paper}`,
    '&::after': {
      position: 'absolute',
      top: 0,
      left: 0,
      width: '100%',
      height: '100%',
      borderRadius: '50%',
      animation: 'ripple 1.2s infinite ease-in-out',
      border: '1px solid currentColor',
      content: '""',
    },
  },
  '@keyframes ripple': {
    '0%': {
      transform: 'scale(.8)',
      opacity: 1,
    },
    '100%': {
      transform: 'scale(2.4)',
      opacity: 0,
    },
  },
}))

export default function BadgeAvatars({ avatarFile = null }) {
  return (
    <Stack direction="row" spacing={2}>
      <StyledBadge overlap="circular">
        <Avatar src={avatarFile ? `${apiUrl}/uploads/${avatarFile}` : ''} />
      </StyledBadge>
    </Stack>
  )
}
